import React from 'react';
import map from 'lodash/map';

import { useResponsiveValue } from '../catering-landing-utils';

const desktopImages = [
  'https://img.peerspace.com/image/upload/q_20/v1730916880/catering/db08129f6083cdc1431c6288ae1ed780.jpg',
  'https://img.peerspace.com/image/upload/v1725383524/ofe9mk0fw0x68ixy4b8s.jpg',
  'https://img.peerspace.com/image/upload/q_20/v1730916880/catering/fe931502e8eff47ec2d615d47e3a9253.jpg',
  'https://img.peerspace.com/image/upload/v1730916880/catering/bed377eb184843c274365de268ce0cea.jpg',
  'https://img.peerspace.com/image/upload/q_20/v1730916880/catering/4d41d729c337309586e03c5a6ace1cfd.jpg',
  'https://img.peerspace.com/image/upload/v1725383524/kh9nhakrff6xfv4d1d36.jpg',
  'https://img.peerspace.com/image/upload/v1730916880/catering/e5cc4e16c50ff2c39fc440a7b49acfa4.jpg',
  'https://img.peerspace.com/image/upload/q_20/v1730916880/catering/ca7162c363b06044b14240b0c4721ad4.jpg'
];

const mobileImages = [
  'https://img.peerspace.com/image/upload/v1725383524/kh9nhakrff6xfv4d1d36.jpg',
  'https://img.peerspace.com/image/upload/q_20/v1730916880/catering/db08129f6083cdc1431c6288ae1ed780.jpg',
  'https://img.peerspace.com/image/upload/q_20/v1730916880/catering/ca7162c363b06044b14240b0c4721ad4.jpg',
  'https://img.peerspace.com/image/upload/v1730916880/catering/e5cc4e16c50ff2c39fc440a7b49acfa4.jpg',
  'https://img.peerspace.com/image/upload/v1725383524/ofe9mk0fw0x68ixy4b8s.jpg',
  'https://img.peerspace.com/image/upload/v1730916880/catering/bed377eb184843c274365de268ce0cea.jpg',
  'https://img.peerspace.com/image/upload/q_20/v1730916880/catering/fe931502e8eff47ec2d615d47e3a9253.jpg'
];

export const CateringLandingHero = () => {
  const images = useResponsiveValue(desktopImages, mobileImages);

  return (
    <div className="catering-landing-hero bg-black">
      <div className="hero-text">
        <div className="catering-landing-hero-content text-center flex center middle column">
          <div className="tw-text-purple-400 tw-headline-1-m catering-now-available-text">
            Now available in LA
          </div>
          <h1 className="no-margin tw-headline-6-b md:tw-display-1-b margin-lg-bottom catering-title-hidden-mobile text-white">
            Catering for your event —
            <br />made easy
          </h1>
          <h1 className="no-margin tw-headline-6-b md:tw-display-1-b margin-lg-bottom catering-title-hidden-desktop text-white">
            Catering for your
            <br />
            event — made easy
          </h1>
          <p className="no-margin tw-body-4 catering-hero-subtext text-white">
            Take your event to the next level with a wide-ranging selection
            of tasty options, curated by top local chefs.
          </p>
        </div>
      </div>
      <div className="catering-landing-hero-images-scroll-container">
        <div className="catering-landing-hero-images">
          {map(images, (image, index) => (
            <img
              className={`hero-img tw-rounded-4 hero-img-${index}`}
              src={image}
              alt={`hero-img-${1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
